import { createRouter, createWebHashHistory  } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/contact',
  //   name: 'Contact us',
  //   component: () => import('@/views/ContactVac.vue'),
  // },
  {
    path: '/about',
    name: 'About VAC',
    component: () => import('@/views/AboutVac.vue'),
  },
  {
    path: '/loan',
    name: 'Loan Rates',
    component: () => import('@/views/LoanVac.vue'),
  },
  {
    path: '/video',
    name: 'Video',
    component: () => import('@/views/VideoVac.vue'),
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/views/BlogVac.vue'),
  },
  {
    path: '/calculate',
    name: 'Calculate',
    component: () => import('@/views/CalculateVac.vue'),
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/views/TermsVac.vue'),
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/PrivacyVac.vue'),
  },
  {
    path: '/card/',
    name: 'Article',
    component: () => import('@/views/BlogArticle.vue'),
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: () => import('@/views/InventoryVac.vue'),
  },
  {
    path: '/Request',
    name: 'Request',
    component: () => import('@/views/RequestCar.vue'),
  },
  {
    path: '/RequestCar/',
    name: 'RequestCar',
    component: () => import('@/views/RequestCarId.vue'),
  },
  {
    path: '/car/',
    name: 'InventoryCar',
    component: () => import('@/views/InventoryArticle.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () => import('@/views/PageNotFound.vue'),
  },
]

const router = createRouter({
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
  },
  history: createWebHashHistory(),
  routes
},
)



export default router
